import { DRAG_LOOP_MS } from "constants/constants";
import { setiMoved, setTranslateAndCalc, startDragLoop } from "./spaceDrag";
import { handlePersonMove, graphicTalking } from "./spaceSignalling";
import {
  myCircle,
  spaceBoxHeight,
  spaceBoxWidth,
  people,
  myLuid,
} from "./spaceVars";

// For testing
export var testingOtherMovement =
  process.env.NODE_ENV !== "production" && false;
export var testingMyMovement = process.env.NODE_ENV !== "production" && false;

export var showLuidOnCircles = process.env.NODE_ENV !== "production" && false;
export var testStarted = false;
export var receivedFPS = 0;
export function setreceivedFPS(val) {
  receivedFPS = val;
}
export var sentFPS = 0;
export function setsentFPS(val) {
  sentFPS = val;
}
export var timer01 = null;
export var timer02 = null;
export var timer03 = null;

export function startTest() {
  if (testStarted) return;
  testStarted = true;
  var lolz = Math.random() * (spaceBoxHeight / 3.2);
  var distance = lolz;
  var angle = lolz;
  var midX = spaceBoxWidth / 2;
  var midY = spaceBoxHeight / 2;
  var dX = midX;
  var dY = midY;
  startDragLoop();
  let value = false;
  let counter = 0;
  timer01 = setInterval(() => {
    angle += 0.02;

    // ME
    if (testingMyMovement) {
      dX = midX + distance * Math.sin(angle);
      dY = midY + distance * Math.cos(angle);
      setTranslateAndCalc(dX, dY, myCircle);
      setiMoved(true);
    }

    if (testingOtherMovement) {
      counter++;
      if (counter % 40 === 0) value = !value;
      for (var luid in people) {
        let myX = people[myLuid].x;
        let myY = people[myLuid].y;
        if (luid !== myLuid && luid % 3 === 0) {
          handlePersonMove(
            myX,
            myY,
            people[luid].x + 0.5 * Math.sin(angle),
            people[luid].y + 0.5 * Math.cos(angle),
            luid
          );
        }
        graphicTalking(luid, luid % 3 ? value : !value);
      }
    }
  }, DRAG_LOOP_MS / 3);

  startFpsCounter();
}

function startFpsCounter() {
  window.efs_debug && window.log("FPS COUNTER STARTED");
  timer02 = setInterval(() => {
    window.efs_debug && window.log("Received FPS: " + receivedFPS);
    receivedFPS = 0;
  }, 1000);

  timer03 = setInterval(() => {
    window.efs_debug && window.log("Sent FPS: " + sentFPS);
    sentFPS = 0;
  }, 1000);
}

// setTimeout(() => {
//   debugger;
// }, 10000);

export function stopTests() {
  clearInterval(timer01);
  clearInterval(timer02);
  clearInterval(timer03);
}
